// Exports
export default {
	"icon": "icon_q931O",
	"iconLarge": "iconLarge_LNN+X"
};
